import React from 'react'

import DoneAllIcon from '@material-ui/icons/DoneAll'
import BookmarkIcon from '@material-ui/icons/Bookmark'
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt'
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty'
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import { makeStyles } from '@material-ui/core'
import { fade } from '@material-ui/core/styles/colorManipulator'
import i18n from './i18n/i18n'

export const APPLICATION_STATUSES = {
  pending: {
    label: i18n.t('profile.entreprise.application.statuses.pending'),
    icon: <HourglassEmptyIcon />
  },
  selected: {
    label: i18n.t('profile.entreprise.application.statuses.selected'),
    icon: <DoneAllIcon />
  },
  maybe: {
    label: i18n.t('profile.entreprise.application.statuses.maybe'),
    icon: <BookmarkIcon />
  },
  rejected: {
    label: i18n.t('profile.entreprise.application.statuses.rejected'),
    icon: <ThumbDownAltIcon />
  },
  hired: {
    label: i18n.t('profile.entreprise.application.statuses.hired'),
    icon: <InsertEmoticonIcon />
  }
}

export const useStatusesStyles = makeStyles((theme) => ({
  selectedChip: {
    color: theme.palette.success.dark,
    borderColor: theme.palette.success.dark,
    backgroundColor: fade(theme.palette.success.main, 0.3)
  },
  maybeChip: {
    color: theme.palette.warning.dark,
    borderColor: theme.palette.warning.dark,
    backgroundColor: fade(theme.palette.warning.main, 0.3)
  },
  rejectedChip: {
    color: theme.palette.error.dark,
    borderColor: theme.palette.error.dark,
    backgroundColor: fade(theme.palette.error.main, 0.3)
  },
  hiredChip: {
    color: theme.palette.primary.dark,
    borderColor: theme.palette.primary.dark,
    backgroundColor: fade(theme.palette.primary.main, 0.3)
  },
  header: {
    '& .ge--MuiCardHeader-subheader': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '380px',
      [theme.breakpoints.down('sm')]: {
        width: '70vw'
      }
    }
  }
}))

export default APPLICATION_STATUSES
